import React from "react";
import { AboutUsCard } from "./aboutUsCard";

export const AboutUs = () => {
  return (
    <div className="aboutEvery" id="aboutUs">
      <AboutUsCard
        isLeft={false}
        item="1"
        title="Бидний зорилго ба даалгавар юу вэ?"
        description="Далайн түвшнээс дээш 100 км-ийн өндөрт Карман хил гэх дэлхийн агаар мандал ба гадаад сансар хоёрыг заагалдаг төсөөллийн хил-зааг байдаг ба бидний зорилго нь түүнд өөрсдийн пуужингаар дамжуулан хүрэх юм"
        text1={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">
              Карман хилд хүрч гадаад сансарт пуужингаа гаргаж байгаа дэлхийн
              хамгийн анхны оюутнууд болох
            </div>
            <div className="popUpText">
              Хэдийгээр АНУ, Энэтхэг, Япон зэрэг дэлхийн шилдэг их сургуулиудын
              оюутнууд өөрсдийн сургуулийн нэрийн дор гадаад сансарт пуужингаа
              хүргэж байсан ч бид нар шиг ямар нэгэн их сургууль болон
              мэргэжлийн байгууллагын ивээл дор бус бие даан хөөргөж байгаагүй
              юм. Бид пуужингаа гадаад сансарт хөөргөснөөр МОНГОЛ УЛС-ынхаа
              нэрийг дэлхийн тавцанд гарах билээ.
            </div>
          </div>
        }
        text2={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">
              Монголоос гадаад сансарт пуужингаа гаргаж байгаа хамгийн анхны
              хүмүүс болох
            </div>
            <div className="popUpText">
              Бид Монголоос гадаад сансарт өөрсдийн хийсэн пуужингаа гаргаж буй
              анхны хүмүүс болох ба орон даяар тэр бүү хил дэлхий даяар энэ
              мэдээ тарна гэдэгт бат итгэлтэй байгаа.
            </div>
          </div>
        }
        text3={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">
              Дэлхийн оюутнуудын пуужингийн өндрийн рекордыг эвдэх
            </div>
            <div className="popUpText">
              Бидний хийсэн пуужин нь далайн түвшнээс дээш 100 км -ийн өндөрт
              хүрэх буюу дэлхийн оюутнуудын пуужингийн тогтоосон өндрийн
              одоогийн рекордыг эвдэх юм. Нислэгийн дараа бид төслийн бүхий л
              мэдээлэл болон пуужинтай холбоотой датануудыг олон нийтэд түгээх
              юм. Ингэснээр Монголд Улсд сонирхогчийн пуужин хөгжих боломжийг
              нээж өгч байгаа болно. Бидний тогтоох рекордыг ахиулах хүмүүс нь
              дараагийн Монгол залуус байх болно гэдэгт итгэлтэй байна
            </div>
          </div>
        }
        id="ourProject"
      />
      <AboutUsCard
        isLeft={true}
        item="2"
        title="Яагаад Говь Гэж?"
        description="Бид өөрсдийн бүтээсэн пуужинг Говь-Алтай аймгийн Баян-уул сумын нутаг дэвсгэрээс хөөргөнө. Бидний хөөргөх цэг нь Монгол Элснээс баруун урагш зүгт 12 км-ийн зайтай газарт байгаа юм. Энэ цэгийг сонгосон шалтгаан нь дараахь 3 шалтгаанаас үүдэлтэй:"
        text1={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">Бидний Алсын Хараа</div>
            <div className="popUpText">
              Өргөн уудам Монгол эх орны нутгаас хамгийн анхны гадаад сансарт
              гарах зорилготой пуужинг Говь цөлөөс хөөргөх болсон бидний гол
              шалтгаан бол бидний алсын хараа билээ. Говь цөлөөс өндөр амбиц
              бүхий анхны пуужинг хөөргөснөөр:
              <p>
                -Нэгдүгээрт. Говь цөлд олон улсын аялал жуулчлалыг хөгжүүлэх
                үндэс суурийг тавих
              </p>
              <p>
                -Хоёрдугаарт. Монголын элсэн цөлд Олон Улсын Агаарын болон
                Сансар судлалын байгууллага байгуулах
              </p>
              <p>
                -Гуравдугаарт. Олон Улсын байгууллагуудын говь цөлийн болон
                хээрийн бүсийн нэн ховордсон ургамал амьтдад тавих анхаарлыг
                илүү төвлөрүүлж, хамгаалах болон үржүүлэх ажлуудыг эхлүүлэх,
                өргөжүүлэх
              </p>
            </div>
          </div>
        }
        text2={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">Эрсдэл - Сэргийлэлт</div>
            <div className="popUpText">
              Энгийнээр хэлвэл пуужин хөөргөхөөр сонгосон говь цөлийн бүс нутаг
              нь хот суурин газар, ямар нэгэн бүтээн байгуулалт, төрийн тусгай
              хамгаалалтын газар байхгүй зэлүүд газар учир сонгон авсан билээ.
              <p>
                -Хамгийн муугаар бодоход манай пуужин нь хөөргөсөн цэгээс 210 км
                радиус дотор буцаж унах тул аль нэг гадаад улсын агаарын болон
                газрын хилийг зөрчиж орохгуй байхаар тооцсон болно. Мөн хамгийн
                боломжит унах зааг буюу 31 км-ийн радиус дотор ямарваа нэгэн
                цэргийн болон иргэний байгууламж байхгуй, олон улсын болон орон
                нутгийн нислэгийн маршрутын замд саад учруулахгүй зэрэг илүү
                боломжийг бүрдүүлч өгч байгаа юм.
              </p>
            </div>
          </div>
        }
        text3={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">Техникийн ашигтай ажил</div>
            <div className="popUpText">
              Монгол элс-ээс баруун урд зүгээс пуужингаа хөөргөнө гэдэг нь
              бидний ашиглах техник болон бидний алсын хараанд хамгийн төгс
              зохицсон газар болж байгаа. Пуужин хөөргөх цэгээс холгүйхэн орших
              уулын оройд бид өөрсдийн 3 ба 4 дүгээр радаруудыг байрлуулах
              болно. Ингэснээр манай радаруудын үзэгдэх орчин ихсэн пуужингийн
              байрлалыг илүү оновчтой тогтооно гэсэн үг юм.
            </div>
          </div>
        }
        id="whyGobi"
      />
      <AboutUsCard
        isLeft={false}
        item="3"
        title="Бид юу хийж байгаа вэ?"
        description="Манай пуужин нь гурван шатлалтай 5.2 м өндөр, 96.7 кг жинтэй, 8 кг-ийн даацтай бөгөөд хөнгөн цагааны нерж болон бусад композит материалаар хийгдэнэ. Дууны хурднаас 5 дахин илүү хурдлах бөгөөд цойлон нисэх нийт хугацаа нь 11 минут 24 секунд байна."
        text1={
          <div style={{ display: "flex" }}>
            <div className="popUpLabel">Пуужингийн өртөг</div>
            <div className="popUpText">
              Зөвхөн пуужинг бүтээх өртөг нь 42000 ам.доллар болох ба бид төсөл
              хэрэгжүүлэх нийт зардлыг босгохын төлөө идэвхитэй хөөцөлдөж байна.
              Анхны төлөвлгөөний дагуу бидний пуужин өнгөрөгч оны 11-р сарын
              31-нд хөөргөхөөр товлож байсан боловч хөрөнгө санхүүжилтийн болон
              цар тахлаас үүдэлтэй хөл хорионы улмаас өдийг хүртэл хойшлогдсон
              юм. Бидэнд энэ төслийг бүрэн хэрэгжүүлэхэд шаардагдах зардлыг
              босгоход санхүүгийн дэмжлэг хэрэгтэй байгаа. Манай төслийн
              хэрэгжүүлэх шахуу цаг хугацаанд үзүүлж байгаа ямар ч хэмжээний
              дэмжлэг тусламжинд бид гүнээ талархах болно. Хэдий чинээ хурдан
              хөрөнгө босгоно төдий чинээ амжилт олох боломж ихсэх юм
            </div>
          </div>
        }
        id="project"
      />
    </div>
  );
};
